<div class="no-items-container">
  <mat-icon [ngStyle]="{'height': sizePx, 'width': sizePx, 'font-size': sizePx }">warning</mat-icon>
  <span>{{ message }}</span>
</div>
